import { Grid } from '@joinrepublic/dls-ui-kit';

import { IBusinessRowData } from './eu-businesses-query';
import { SecondaryMarketRow } from './secondary-market-row';

export interface ISecondaryMarketTableProps {
  deals: IBusinessRowData[];
}

export const SecondaryMarketTable = ({ deals }: ISecondaryMarketTableProps) => {
  const dealsHalfIndex = Math.ceil(deals.length / 2);
  const dealsGroup = [
    deals.slice(0, dealsHalfIndex),
    deals.slice(dealsHalfIndex),
  ];

  return (
    <Grid
      templateColumns={{ base: '1fr', md: '1fr 1fr' }}
      columnGap={{ base: '8', sm: '5%', lg: '7%' }}
      overflow="hidden"
    >
      {dealsGroup.map((group, index) => (
        <div key={index}>
          {group.map((deal) => (
            <SecondaryMarketRow key={deal.id} deal={deal} />
          ))}
        </div>
      ))}
    </Grid>
  );
};
